/* eslint-disable react/require-default-props */
import { Box, Grid } from '@mui/material';

import {
  convertConservationState,
  convertStandard,
  convertStandard400K,
} from '../../../api/enumerations';
import { WorkOrderData } from '../../../api/workOrders/types';
import {
  parcelGroup,
  privateUnitsGroup,
} from '../../../constants/selectOptions';
import { InputTitle, SmallStyledInput } from '../../UI/Typography';
import { Constants } from './constants';

interface PropertyInfoProps {
  propertyData?: WorkOrderData;
}

export function PropertyInfo({ propertyData }: PropertyInfoProps): JSX.Element {
  const isParcelGroup =
    propertyData?.real_estate_kind !== undefined &&
    parcelGroup.has(propertyData?.real_estate_kind);
  const isPrivateUnits =
    propertyData?.real_estate_kind !== undefined &&
    privateUnitsGroup.has(propertyData.real_estate_kind);

  const checkStandard = (data: WorkOrderData): string => {
    if (data.constructive_standard) {
      if (data.status > 6 && data.sample_sell_price_above_400k) {
        return convertStandard400K(data.constructive_standard);
      }
      return convertStandard(data.constructive_standard);
    }
    return '';
  };
  return (
    <Box>
      {!isParcelGroup ? (
        <Grid container spacing={4}>
          <Grid item xs={2.5}>
            <InputTitle>
              {isPrivateUnits ? Constants.totalArea : Constants.landArea}
            </InputTitle>
            <SmallStyledInput>{propertyData?.total_area}</SmallStyledInput>
          </Grid>
          <Grid item xs={2.5}>
            <InputTitle>
              {isPrivateUnits
                ? Constants.privateArea
                : Constants.constructedArea}
            </InputTitle>
            <SmallStyledInput>
              {propertyData?.constructed_area}
            </SmallStyledInput>
          </Grid>
          <Grid item xs={2}>
            <InputTitle>{Constants.rooms}</InputTitle>
            <SmallStyledInput>{propertyData?.bedrooms}</SmallStyledInput>
          </Grid>
          <Grid item xs={2}>
            <InputTitle>{Constants.toilets}</InputTitle>
            <SmallStyledInput>{propertyData?.bathrooms}</SmallStyledInput>
          </Grid>
          <Grid item xs={2}>
            <InputTitle>{Constants.suites}</InputTitle>
            <SmallStyledInput>{propertyData?.suites}</SmallStyledInput>
          </Grid>
          <Grid item xs={2.5}>
            <InputTitle>{Constants.parkingLots}</InputTitle>
            <SmallStyledInput>{propertyData?.parking_spaces}</SmallStyledInput>
          </Grid>
          <Grid item xs={2.5}>
            <InputTitle>{Constants.propertyAge}</InputTitle>
            <SmallStyledInput>
              {propertyData?.age}
              {propertyData?.age === 1 ? Constants.year : Constants.years}
            </SmallStyledInput>
          </Grid>
          <Grid item xs={2.5}>
            <InputTitle>{Constants.standard}</InputTitle>
            <SmallStyledInput>
              {propertyData?.constructive_standard &&
                checkStandard(propertyData)}
            </SmallStyledInput>
          </Grid>
          <Grid item xs={3.5}>
            <InputTitle>{Constants.conservation}</InputTitle>
            <SmallStyledInput>
              {propertyData?.preservation_state &&
                convertConservationState(propertyData?.preservation_state)}
            </SmallStyledInput>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={2.5}>
            <InputTitle>{Constants.landArea}</InputTitle>
            <SmallStyledInput>{propertyData?.total_area}</SmallStyledInput>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}
